/* global Draggable, mzFunc */

import React, { useEffect, useState, useRef } from 'react';
import ReactHtmlParser from 'react-html-parser';
import GTMHelper from '../../../Helpers/gtmHelper';
import SummaryCalculator from '../../../Helpers/summarycalculator';
import { useTranslation } from "react-i18next";

export const ThreeSixtyView = ({ imagePath, imageAmount, imageName, isLoading, ...props }) => {
	const [summaryCalculator = new SummaryCalculator().reloadStoredData(), setSummaryCalculator] = React.useState();
	const [imageList, setImageList] = React.useState(null)
    const ts = useRef();
	const [trigger, setTrigger] = React.useState(ts.current)
	const [imageCount, setImageCount] = React.useState(1);
	const [draggableIsReady, setDraggableIsReady] = React.useState(false);
	const gtmHelper = new GTMHelper();

    const getImages = ()=>{
        let images ='';
        for(let i=1;i<=parseInt(imageAmount);i++){
            images+=`<img src="${imagePath}${imageName.replace('{index}', i)}" />`;
        }
        return images;
    }

    function preventScroll(e) {
        e.stopPropagation();
        return false;
    }
	function enableDraggable(){
		//console.log(!ts, !ts.current, trigger == undefined)
		if(!ts || !ts.current || trigger == undefined)
			return;

		//console.log('enableDraggable', imageCount)

		if(typeof Draggable == 'function'){
			Draggable.create(trigger, {
				type: "x",
				lockAxis: true,
				force3D: true,
				zIndexBoost: false,
				currentPos: summaryCalculator.Current360Rotation,
				minimumMovement: 2, // moves more than 2px to be interpreted as a drag.
				onDragStart: function () {
					this.target.classList.add('dragging')
					gtmHelper.setGTM({'action':'Drag Exterior'}, false , false);
				},
				onDrag: function () {
					// there is an extra drag event fired on mouse up that has x = 0, so check this.isDragging to skip that last one
					if (this.isDragging) {
						let target = this.target;
						let deltaX = this.deltaX;

						// When dragged forward (right)
						if (deltaX > 0) {
							if (this.vars.currentPos === imageCount - 1) {
								this.vars.currentPos = 0;
							} else if (this.vars.currentPos < imageCount - 1) {
								this.vars.currentPos += 1;
							}
						}
						// When dragged backward (left)
						else if (deltaX < 0) {
							if (this.vars.currentPos === 0) {
								this.vars.currentPos = imageCount - 1;
							} else if (this.vars.currentPos > 0) {
								this.vars.currentPos -= 1;
							}
						}

						target.style.transform = `translate(-${this.vars.currentPos * 100}%, 0)`;
						summaryCalculator.Current360Rotation=this.vars.currentPos;
					}
				},
				onDragEnd: function () {
					this.target.classList.remove('dragging')
				}
			});
			trigger.style.transform = `translate(-${summaryCalculator.Current360Rotation * 100}%, 0)`;
		}
	}
	window.addEventListener('resize', set360Height);

	function set360Height(){
		const container = document.querySelector('.mz-360-container');
		const subnav =  document.querySelector('.mz-sticky-submenu');
		const pricing = document.querySelector('.mz-pricing');
		const imageCont = document.querySelector('.mz-360-image-container');
		const title = document.querySelector('.mz-360-container__tittle');
		const controls = document.querySelector('.mz-360-container__controls');
		const incentivebar = document.querySelector('.mz-alert__item'); // Red alert bar
		if(imageCont !== null && controls !== undefined && container){
			if(window.innerWidth > 1023 && subnav !== undefined && pricing !== undefined && pricing != null){
				const alert = mzFunc ? mzFunc.offsetAlert : 0;
				const permAlert = mzFunc ? mzFunc.offsetPermAlert : 0;
				const menu = document.querySelector('.mz-menu');
				let viewHeight = window.innerHeight - ( alert + permAlert + (menu ? menu.clientHeight : 0) + (subnav ? subnav.clientHeight : 0) + (pricing ? pricing.clientHeight : 0) + (incentivebar ? incentivebar.clientHeight : 0));
				//viewHeight = viewHeight<450? 450 : viewHeight;
				imageCont.style.height= (viewHeight - (title.clientHeight + (controls ? controls.clientHeight : 0))) +'px';
				container.dataset['height']=imageCont.style.height;
			}else{
				container.dataset['height']=imageCont.clientHeight + 'px';
				imageCont.style.height=null;
			}
		}
	}



	React.useEffect(() => {
		setImageList(getImages());

		if(ts.current?.querySelector('.mz-images-rotator-content')){
			setTrigger(ts.current.querySelector('.mz-images-rotator-content'));
			setImageCount(trigger?.querySelectorAll('img')?.length);
		}

		if(!draggableIsReady){
			const ref = setInterval(() => {
				if(typeof Draggable == 'function' && imageCount > 1) {
					setDraggableIsReady(true);
					clearInterval(ref);
				}
			}, 100);
		}
	}, [imageName, imageList, imageCount, isLoading]);
	
	React.useEffect(() => {
		set360Height();
		enableDraggable();
		ts.current.addEventListener("wheel", preventScroll);
		ts.current.addEventListener("scroll", preventScroll);
	}, [draggableIsReady]);
		
    return (
        <div className="mz-360-image-container" ref={ts}>
			<div className="mz-images-rotator-inner">
      			<div className="mz-images-rotator-content">
					{!imageList ? <img src="/globalassets/mazda-canada/build-and-price/360_loadinganimation.gif" /> : ReactHtmlParser(imageList)}
				</div>
			</div>
        </div>
    )
}

export default ThreeSixtyView; 